/**
 * use-user.js
 */

import React from 'react';
import axios from 'axios';

export default function useUser(userId, detailed = true) {
  const [user, setUser] = React.useState();

  React.useEffect(() => {
    (async() => {
      if (userId) {
        const response = await axios.get(`/account/${userId}?detailed=${detailed}`);
        if (response.status === 200) {
          setUser(response.data);
        }
      }
    })();
    return () => {
      setUser();
    };
  }, [userId, detailed]);

  return user;
}